// Texa Desk redesign (R1): the legacy FluentIcon component draws these with
// their Lucide twin, so every icon in the Desk comes from one family. Brand
// marks (WhatsApp, Instagram…) and the priority glyphs keep their own drawing.
// Full class names are written out so Tailwind generates them.
export const TEXA_FLUENT_TO_LUCIDE = {
  add: 'i-lucide-plus',
  'add-circle': 'i-lucide-circle-plus',
  alarm: 'i-lucide-alarm-clock',
  'alarm-off': 'i-lucide-alarm-clock-off',
  'alarm-on': 'i-lucide-alarm-clock-check',
  alert: 'i-lucide-bell',
  appearance: 'i-lucide-palette',
  archive: 'i-lucide-archive',
  'arrow-chevron-left': 'i-lucide-chevron-left',
  'arrow-chevron-right': 'i-lucide-chevron-right',
  'arrow-clockwise': 'i-lucide-rotate-cw',
  'arrow-download': 'i-lucide-download',
  'arrow-expand': 'i-lucide-maximize-2',
  'arrow-outwards': 'i-lucide-arrow-up-right',
  'arrow-redo': 'i-lucide-redo-2',
  'arrow-reply': 'i-lucide-reply',
  'arrow-right': 'i-lucide-arrow-right',
  'arrow-right-import': 'i-lucide-log-in',
  'arrow-rotate-clockwise': 'i-lucide-rotate-cw',
  'arrow-rotate-counter-clockwise': 'i-lucide-rotate-ccw',
  'arrow-sort': 'i-lucide-arrow-up-down',
  'arrow-swap': 'i-lucide-arrow-left-right',
  'arrow-trending-lines': 'i-lucide-trending-up',
  'arrow-up': 'i-lucide-arrow-up',
  'arrow-up-right': 'i-lucide-arrow-up-right',
  attach: 'i-lucide-paperclip',
  autocorrect: 'i-lucide-spell-check',
  automation: 'i-lucide-workflow',
  'avatar-upload': 'i-lucide-image-up',
  book: 'i-lucide-book',
  'book-clock': 'i-lucide-book-open',
  'book-contacts': 'i-lucide-book-user',
  'book-copy': 'i-lucide-copy',
  'book-open-globe': 'i-lucide-book-open',
  'book-pulse': 'i-lucide-book-open',
  bot: 'i-lucide-bot',
  briefcase: 'i-lucide-briefcase',
  'building-bank': 'i-lucide-landmark',
  calendar: 'i-lucide-calendar',
  'calendar-clock': 'i-lucide-calendar-clock',
  call: 'i-lucide-phone',
  chat: 'i-lucide-message-square',
  'chat-help': 'i-lucide-message-circle-question',
  'chat-multiple': 'i-lucide-messages-square',
  checkmark: 'i-lucide-check',
  'checkmark-circle': 'i-lucide-circle-check',
  'checkmark-double': 'i-lucide-check-check',
  'checkmark-square': 'i-lucide-square-check',
  'chevron-down': 'i-lucide-chevron-down',
  'chevron-left': 'i-lucide-chevron-left',
  'chevron-left-single': 'i-lucide-chevron-left',
  'chevron-right': 'i-lucide-chevron-right',
  'chevron-right-single': 'i-lucide-chevron-right',
  'chevron-up': 'i-lucide-chevron-up',
  'chevrons-left': 'i-lucide-chevrons-left',
  'chevrons-right': 'i-lucide-chevrons-right',
  clipboard: 'i-lucide-clipboard',
  cloud: 'i-lucide-cloud',
  'cloud-backup': 'i-lucide-cloud-upload',
  code: 'i-lucide-code',
  'comment-add': 'i-lucide-message-square-plus',
  'contact-card': 'i-lucide-contact',
  'contact-card-group': 'i-lucide-users',
  'contact-identify': 'i-lucide-id-card',
  'content-settings': 'i-lucide-settings-2',
  copy: 'i-lucide-copy',
  'credit-card-person': 'i-lucide-credit-card',
  delete: 'i-lucide-trash-2',
  dismiss: 'i-lucide-x',
  'dismiss-circle': 'i-lucide-circle-x',
  document: 'i-lucide-file',
  'document-error': 'i-lucide-file-warning',
  'document-list-clock': 'i-lucide-file-clock',
  'document-text-link': 'i-lucide-file-symlink',
  download: 'i-lucide-download',
  draft: 'i-lucide-file-pen',
  drag: 'i-lucide-grip-vertical',
  'dual-screen-clock': 'i-lucide-clock',
  edit: 'i-lucide-pencil',
  emoji: 'i-lucide-smile',
  'emoji-add': 'i-lucide-smile-plus',
  'error-circle': 'i-lucide-circle-alert',
  'eye-hide': 'i-lucide-eye-off',
  'eye-show': 'i-lucide-eye',
  'file-upload': 'i-lucide-file-up',
  filter: 'i-lucide-list-filter',
  flame: 'i-lucide-flame',
  'flash-on': 'i-lucide-zap',
  'flash-settings': 'i-lucide-zap',
  folder: 'i-lucide-folder',
  globe: 'i-lucide-globe',
  'globe-desktop': 'i-lucide-monitor',
  'globe-line': 'i-lucide-globe',
  'grab-handle': 'i-lucide-grip-vertical',
  'headphones-sound-wave': 'i-lucide-headphones',
  'headset-add': 'i-lucide-headset',
  'heart-handshake': 'i-lucide-heart-handshake',
  image: 'i-lucide-image',
  info: 'i-lucide-info',
  information: 'i-lucide-info',
  key: 'i-lucide-key-round',
  keyboard: 'i-lucide-keyboard',
  library: 'i-lucide-library',
  link: 'i-lucide-link',
  list: 'i-lucide-list',
  location: 'i-lucide-map-pin',
  'lock-closed': 'i-lucide-lock',
  'lock-shield': 'i-lucide-shield-check',
  mail: 'i-lucide-mail',
  'mail-inbox': 'i-lucide-inbox',
  'mail-inbox-all': 'i-lucide-inbox',
  'mail-unread': 'i-lucide-mail',
  map: 'i-lucide-map',
  megaphone: 'i-lucide-megaphone',
  mention: 'i-lucide-at-sign',
  merge: 'i-lucide-merge',
  microphone: 'i-lucide-mic',
  'microphone-off': 'i-lucide-mic-off',
  'microphone-pause': 'i-lucide-pause',
  'microphone-play': 'i-lucide-play',
  'microphone-stop': 'i-lucide-square',
  'more-horizontal': 'i-lucide-ellipsis',
  'more-vertical': 'i-lucide-ellipsis-vertical',
  navigation: 'i-lucide-navigation',
  'number-symbol': 'i-lucide-hash',
  open: 'i-lucide-external-link',
  'pane-close': 'i-lucide-panel-left-close',
  'pane-open': 'i-lucide-panel-left-open',
  'panel-contract': 'i-lucide-panel-right-close',
  'panel-sidebar': 'i-lucide-panel-left',
  pen: 'i-lucide-pen-line',
  people: 'i-lucide-users',
  'people-team': 'i-lucide-users-round',
  'people-team-add': 'i-lucide-user-plus',
  person: 'i-lucide-user',
  'person-account': 'i-lucide-circle-user',
  'person-add': 'i-lucide-user-plus',
  'person-assign': 'i-lucide-user-check',
  'play-circle': 'i-lucide-circle-play',
  'plus-sign': 'i-lucide-plus',
  power: 'i-lucide-power',
  'preview-link': 'i-lucide-link-2',
  quote: 'i-lucide-quote',
  repeat: 'i-lucide-repeat',
  'resize-large': 'i-lucide-maximize-2',
  save: 'i-lucide-save',
  'scan-person': 'i-lucide-scan-face',
  search: 'i-lucide-search',
  'search-check': 'i-lucide-search-check',
  send: 'i-lucide-send-horizontal',
  'send-clock': 'i-lucide-send-horizontal',
  settings: 'i-lucide-settings',
  share: 'i-lucide-share-2',
  signature: 'i-lucide-signature',
  snooze: 'i-lucide-alarm-clock',
  'sort-icon': 'i-lucide-arrow-down-up',
  'sound-source': 'i-lucide-audio-lines',
  'speaker-1': 'i-lucide-volume-1',
  'speaker-mute': 'i-lucide-volume-x',
  square: 'i-lucide-square',
  'star-emphasis': 'i-lucide-star',
  status: 'i-lucide-circle-dot',
  subtract: 'i-lucide-minus',
  'table-switch': 'i-lucide-table',
  tag: 'i-lucide-tag',
  'text-copy': 'i-lucide-copy',
  'text-grammar-wand': 'i-lucide-wand-sparkles',
  translate: 'i-lucide-languages',
  unlink: 'i-lucide-unlink',
  upload: 'i-lucide-upload',
  video: 'i-lucide-video',
  'video-add': 'i-lucide-video',
  wand: 'i-lucide-wand-sparkles',
  warning: 'i-lucide-triangle-alert',
  wifi: 'i-lucide-wifi',
  'wifi-off': 'i-lucide-wifi-off',
  'zoom-in': 'i-lucide-zoom-in',
  'zoom-out': 'i-lucide-zoom-out',
};
